import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=6aa5b9c4"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2906744869/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa5b9c4')) {
      api.createRecord('6aa5b9c4', component.options)
    } else {
      api.reload('6aa5b9c4', component.options)
    }
    module.hot.accept("./AlertDialog.vue?vue&type=template&id=6aa5b9c4", function () {
      api.rerender('6aa5b9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertDialog.vue"
export default component.exports